import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';

export function renderMessages(messages, setSuccessData) {
    const alerts = messages.map(function (message, i) {        
        const [show, setShow] = useState(true);

        window.setTimeout(()=>{
            setSuccessData(null);
            setShow(false);
        }, 5000);

        if(show){
            return (<Alert
                key={i}
                className="mb-2"
                variant="success"
                show={show}
                onClose={() => setShow(false)}
                dismissible
            >
                {message}
            </Alert>);
        }
        return <></>
    })

    return <div>{alerts}</div>;
};